import * as React from "react";
import { SideNavigation } from "AWS-UI-Components-React";
import { navigationItems } from "../data/constdata";
 
class Navigation extends React.Component {
 
  render() {
    return (
      <SideNavigation
        header={{ text: "CEV TaaS", href: "/" }}
        items={navigationItems}
        activeHref="#/"
      />
    );
  }
}
 
export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation.jsx